export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('addDays', (date: Date, days: number) => {
    if (!date) return null
    const copy = new Date(Number(date))
    copy.setDate(date.getDate() + days)
    return copy
  })

  nuxtApp.provide('displayDate', (date: Date | null) => {
    if (!date) return '-'
    const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'][date.getDay()]
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日(${dayOfWeek})`
  })
})
